import React from "react"
import PropTypes, { string } from "prop-types"
import { Row, Col, BreadcrumbItem } from "reactstrap"

const Breadcrumb = props => {
  return (
    <Row>
      <Col xs="12">
        <div 
          className="page-title-box d-sm-flex align-items-center justify-content-between" 
          style={{minHeight: "47px"}}
        >
          <h4 className="mb-1 font-size-18">{props.title}</h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              {props.breadcrumbItem !== string && (
                <BreadcrumbItem>{props.breadcrumbItem}</BreadcrumbItem>
              )}
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.any,
  title: PropTypes.string,
}

export default Breadcrumb
